export default "__VITE_ASSET__BDqw9iz___"